// extracted by mini-css-extract-plugin
module.exports = {"BackButton":"BackButton_BackButton__2eyuB","Button":"BackButton_Button__3EQiu"};